export const SERVICES_LIST = [{
  headerKey: 'services.pair.header',
  descriptionKey: 'services.pair.description',
  prices: {
    basic: 135,
    twoMonths: 120,
    prev: {
      basic: 160,
      twoMonths: 144
    }
  },
  benefitsKeys: ['services.pair.benefits.0', 'services.pair.benefits.1', 'services.pair.benefits.2', 'services.pair.benefits.3'],
  link: '/pair-lessons',
  isServicePrimary: false,
  isExternalLink: false
}, {
  headerKey: 'services.individual.header',
  descriptionKey: 'services.individual.description',
  prices: {
    basic: 215,
    twoMonths: 195,
    prev: {
      basic: 265,
      twoMonths: 240
    }
  },
  benefitsKeys: ['services.individual.benefits.0', 'services.individual.benefits.1', 'services.individual.benefits.2', 'services.individual.benefits.3'],
  link: '/individual-lessons',
  isServicePrimary: true,
  isExternalLink: false
}, {
  headerKey: 'services.corporate.header',
  descriptionKey: 'services.corporate.description',
  benefitsKeys: ['services.corporate.benefits.0', 'services.corporate.benefits.1', 'services.corporate.benefits.2', 'services.corporate.benefits.3'],
  link: process.env.NEXT_PUBLIC_B2B_URL ?? '',
  isServicePrimary: false,
  isExternalLink: true
}];
export type ServiceItem = (typeof SERVICES_LIST)[number];